
/** @format */

import React from 'react';
import {
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Button,
} from '@mui/material';
import { useStyles } from './style';
import jMoment from 'moment-jalaali';
import { numberWithCommas } from 'utility';
import clsx from 'clsx';
import copy from 'copy-to-clipboard';
import createToast from 'components/Toast/Toast';
import { Icons } from 'components';
import { useNavigate } from 'react-router-dom';
import { VOUCHER_TYPES, PERCENTAGE_VOUCHER_INDEXES } from '../../../constants/VoucherConsts';
import { useCurrencyUnit } from 'hooks';

const Constraints = ({ codes = [], totalCount = 0, user }) => {
  // --HOOKS--//
  const navigate = useNavigate();
  const classes = useStyles();

  const currencyText = useCurrencyUnit(false);

  // -- API REQUESTS --//
  const copyItem = async (v) => {
    try {
      await copy(v);
      createToast('موفق', 'کد بن کپی شد.', 'success');

    } catch (e) {
      createToast('خطا', 'خطا در کپی کردن کد بن.', 'danger');

    }
  };
  return codes?.length === 0 ? (
    <div />
  ) : (
    <Grid
      container
      direction="row"
      alignItems="center"
      item
      className={classes.root}
    >
      <Grid item xs={12}>
        <Grid container xs={12} md={9} className={classes.info}>
          <Grid item xs={12} md={6} lg={4} className={classes.detail}>
            <Typography className={classes.detailTitle}>نوع بن صادر شده</Typography>
            <Typography className={classes.detailValue}>
              {VOUCHER_TYPES[codes[0]?.type] ?? '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={4} className={classes.detail}>
            <Typography className={classes.detailTitle}>تعداد بن صادر شده</Typography>
            <Typography className={classes.detailValue}>{codes?.length ?? '-'} عدد</Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={4} className={classes.detail}>
            <Typography className={classes.detailTitle}>تاریخ شروع</Typography>
            <Typography className={classes.detailValue}>
              {codes[0]?.effectiveDate
                ? jMoment(new Date(parseInt(codes[0].effectiveDate)))?.format(
                  'dddd, jD jMMMM jYYYY',
                ) ?? '-'
                : '-'}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6} lg={4} className={classes.detail}>
            <Typography className={classes.detailTitle}>
              {PERCENTAGE_VOUCHER_INDEXES.includes(codes[0]?.type) ? 'درصد تخفیف' : 'مبلغ تخفیف'}
            </Typography>
            <Typography className={classes.detailValue}>
              {PERCENTAGE_VOUCHER_INDEXES.includes(codes[0]?.type)
                ? numberWithCommas(codes[0]?.discountPercentage ?? '')
                : codes[0]?.creditAmount
                  ? <PriceLabel amount={codes[0].creditAmount} currency={currencyText} />
                  : 'بدون مبلغ'}
            </Typography>
          </Grid>
          {PERCENTAGE_VOUCHER_INDEXES.includes(codes[0]?.type) ? (
            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>سقف تخفیف</Typography>
              <Typography className={classes.detailValue}>
                {codes[0]?.creditAmount
                  ? <PriceLabel amount={codes[0].creditAmount} currency={currencyText} />
                  : 'بدون سقف'}
              </Typography>
            </Grid>
          ) : null}
          <Grid item xs={12} md={6} lg={4} className={classes.detail}>
            <Typography className={classes.detailTitle}>تاریخ انقضا</Typography>
            <Typography className={classes.detailValue}>
              {codes[0]?.expireDate
                ? jMoment(codes[0].expireDate)?.format('dddd, jD jMMMM jYYYY') ?? '-'
                : '-'}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6} lg={4} className={classes.detail}>
            <Typography className={classes.detailTitle}>محدودیت روی محل مصرف</Typography>
            <Typography className={classes.detailValue}>
              {codes[0]?.guild ? codes[0]?.guild?.name : 'ندارد'}
            </Typography>
          </Grid>
          {codes[0]?.limitedConsumer ? (
            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>کاربر مجاز به استفاده</Typography>
              <Typography className={classes.detailValue}>
                {codes[0]?.limitedConsumer?.id}. {codes[0]?.limitedConsumer?.name}
              </Typography>
            </Grid>
          ) : null}
          <Grid
            item
            xs={12}
            md={codes[0]?.productList?.length < 5 ? 6 : 12}
            lg={codes[0]?.productList?.length < 5 ? 8 : 12}
            className={classes.detail}
          >
            <Typography className={classes.detailTitle}>قابل استفاده بر روی محصولات</Typography>
            <Typography className={classes.detailValue}>
              {codes[0]?.productList?.length <= 0
                ? 'همه محصولات'
                : codes[0]?.productList?.map((v, k) => (
                  <span key={k}>{`${k !== 0 ? '،' : ''}${v?.id}. ${v?.name}`}</span>
                ))}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={codes[0]?.dealerBusinessList?.length < 5 ? 6 : 12}
            lg={codes[0]?.dealerBusinessList?.length < 5 ? 8 : 12}
            className={classes.detail}
          >
            <Typography className={classes.detailTitle}>قابل استفاده توسط کارگزاران</Typography>
            <Typography className={classes.detailValue}>
              {codes[0]?.dealerBusinessList?.length <= 0
                ? '-'
                : codes[0]?.dealerBusinessList?.map((v, k) => (
                  <span key={k} style={{ margin: '0 10px', display: 'inline-block' }}>
                    {`${k !== 0 ? '،' : ''}${v?.id}. ${v?.name}`}
                  </span>
                ))}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6} lg={4} style={{ marginTop: 20 }}>
        <List dense={false} className={classes.list}>
          <ListItem className={classes.titleBox}>
            <ListItemText primary="شماره" />
            <ListItemText primary="کد بن" />
          </ListItem>
          {codes.map((v, k) => (
            <ListItem key={k} className={clsx(k % 2 !== 0 ? 'odd' : '', classes.listItem)}>
              <ListItemText primary={v?.id} />
              <ListItemText primary={v?.hash} />
              <ListItemSecondaryAction>
                <IconButton
                  className={classes.copyIcon}
                  onClick={() => copyItem(v?.hash)}
                  size="large">
                  <Icons icon="copy" color="#d1d8dc" hover="#303d8f" size="20" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Grid>
      {totalCount > 10 ? (
        <Grid item xs={12} className={classes.moreContainer}>
          <Typography className={classes.more}>
            برای مشاهده همه بن‌های ایجاد شده به صفحه
            <Button
              onClick={() => navigate('/Voucher')}
              className={classes.moreButton}
              color="primary"
            >
              لیست بن‌های تخفیف
            </Button>
            مراجعه کنید.
          </Typography>
        </Grid>
      ) : null}
    </Grid>
  );
};



export default Constraints;
